import { EventEmitter, Injectable, Output, Directive } from "@angular/core";
import {Registration} from "../../models/registration";

@Directive()
@Injectable()
export class RequirementService {

  public serviceId: string;
  public registration: Registration;
  public documentRequirementList: any[];
  public documentRequirement: any;
  public requirement: any;
  public addNew: boolean;
  public showDeterminantBuilder: boolean;

  @Output() public editData: EventEmitter<any> = new EventEmitter();
  @Output() public change: EventEmitter<any> = new EventEmitter();
  @Output() public update: EventEmitter<any> = new EventEmitter();

  public initEdit() {
    this.editData.emit({
      serviceId: this.serviceId,
      registration: this.registration,
      documentRequirement: this.documentRequirement,
      requirement: this.requirement,
      addNew: this.addNew,
      showDeterminantBuilder: this.showDeterminantBuilder,
    });
  }

  public updateData() {
    this.update.emit({
      update: true,
    });
  }

}
